export const roundHalf = num => Math.round(num * 2) / 2;
